"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var TdWebService_1 = __importDefault(require("../../service/TdWebService"));
var react_i18next_1 = require("react-i18next");
var TdLink = /** @class */ (function (_super) {
    __extends(TdLink, _super);
    function TdLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TdLink.prototype.onClick = function (e) {
        //e.preventDefault();
        //e.stopPropagation();
        var _this = this;
        var _a = this.props, action = _a.action, href = _a.href, anchorText = _a.anchorText, anchorMessageId = _a.anchorMessageId, anchorMessageValue = _a.anchorMessageValue, t = _a.t;
        var _anchorText = anchorText;
        if (anchorMessageId) {
            _anchorText = t(anchorMessageId, anchorMessageValue);
        }
        return TdWebService_1.default.userMenu(action, href, _anchorText).then(function () {
            //window.location.href = href;
            if (_this.props.onClick && !href) {
                _this.props.onClick();
            }
        });
    };
    TdLink.prototype.render = function () {
        var _a = this.props, className = _a.className, href = _a.href, openOnNewTab = _a.openOnNewTab;
        return (react_1.default.createElement("a", { className: className, onClick: this.onClick.bind(this), target: openOnNewTab ? '_blank' : '_self', href: href }, this.props.children));
    };
    TdLink.propTypes = {
        t: prop_types_1.default.any.isRequired,
        className: prop_types_1.default.string,
        href: prop_types_1.default.string,
        action: prop_types_1.default.string,
        anchorText: prop_types_1.default.string,
        anchorMessageId: prop_types_1.default.string,
        anchorMessageValue: prop_types_1.default.object,
        openOnNewTab: prop_types_1.default.bool,
        onClick: prop_types_1.default.func,
    };
    return TdLink;
}(react_1.default.Component));
exports.default = react_i18next_1.withTranslation()(TdLink);
